import { Group, Burger, ActionIcon } from '@mantine/core';
import { IconAdjustmentsHorizontal } from "@tabler/icons-react";
import { useConfig } from "../contexts/config-context";
import { UserNav } from "./user-nav";

export function SiteHeader({ mobileOpened, toggleMobile, desktopOpened, toggleDesktop }) {
  const { isGeneratorPage, isConfigOpen, setIsConfigOpen } = useConfig();

  return (
    <Group h="100%" px="md" justify="space-between">
      <Group>
        <Burger opened={mobileOpened} onClick={toggleMobile} hiddenFrom="sm" size="sm" />
        <Burger opened={desktopOpened} onClick={toggleDesktop} visibleFrom="sm" size="sm" />
      </Group>
      
      <Group>
        {isGeneratorPage && (
           <ActionIcon 
             variant="subtle" 
             onClick={() => setIsConfigOpen(!isConfigOpen)}
             color={isConfigOpen ? 'cyan' : 'gray'}
             size="lg"
           >
             <IconAdjustmentsHorizontal size={20} />
           </ActionIcon>
        )}
        <UserNav /> 
      </Group>
    </Group>
  );
}
